<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zKEO17/tc-custom/9780819572127.jpg?1718078527085" alt="This image is the cover for the book Hinge & Sign"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hinge & Sign
      </h1>
      <p class="bookDescription body article font2">
        <p>A renowned poet's artful collection is a striking body of work.<br/>  </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Heather McHugh
      </h2>
      
      <p class="authorDescription body article"> HEATHER MCHUGH is Milliman Distinguished Writer-in-Residence and Professor of English at the University of Washington in Seattle. She regularly teaches at the low residency MFA Program at Warren Wilson College. She is the author of six books of poetry, including, most recently, <I>The Father of the Predicaments</I> (Wesleyan 1999). In 1993, Wesleyan published her literary essays, <I>Broken English: Poetry and Partiality</I>. She has translated the work of Jean Follain, and with her husband Nikolai Popov, the work of Blaga Dimitrova and <I>Glottal Stop: 101 Poems by Paul Celan</I> (Wesleyan 2000). In 1999, she was elected a chancellor of the Academy of American Poets. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wesleyan University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7a67b9a4